const View = require('public_framework/view')
// NOTE: file-saver version 1.3.3 was the only working well in Safari, please be careful when updating...
const {saveAs} = require('file-saver')
const URI = require('urijs')

function downloadBlob (name, data) {
  const blob = new window.Blob([data])
  saveAs(blob, name)
}

module.exports = class AddToCalendar extends View {
  constructor () {
    super(...arguments)
    this.event = this.$el.data('event')
  }

  get events () {
    return {
      'click @btn_google': 'handleGoogle',
      'click @btn_outlook': 'handleOutlook',
      'click @btn_ics': 'handleICS'
    }
  }

  handleICS () {
    const ics = [
      `BEGIN:VCALENDAR`,
      `VERSION:2.0`,
      `PRODID:-//Toptal//NONSGML v1.0 Events//EN`,
      `BEGIN:VEVENT`,
      `UID:${this.event.name}`,
      `DTSTAMP:20120315T170000Z`,
      `ATTENDEE;CN=My Self ;RSVP=TRUE:MAILTO:me@gmail.com`,
      `ORGANIZER;CN=Me:MAILTO:community@toptal.com`,
      `DTSTART:${this.event.startDate}`,
      `DTEND:${this.event.endDate}`,
      `LOCATION:${this.event.location}`,
      `DESCRIPTION:${this.event.description}`,
      `SUMMARY:${this.event.name}`,
      `END:VEVENT`,
      `BEGIN:VALARM`,
      `ACTION:DISPLAY`,
      `DESCRIPTION:REMINDER`,
      `TRIGGER:${this.event.notifyMituesBefore}`,
      `END:VALARM`,
      `END:VCALENDAR`
    ].join('\n')

    downloadBlob(`${this.event.fileName}.ics`, ics)
  }

  handleOutlook () {
    const url = URI('https://outlook.live.com/owa/?path=/calendar/action/compose').search({
      rru: 'addevent',
      startdt: this.event.startDateIso8601,
      enddt: this.event.endDateIso8601,
      subject: this.event.name,
      location: this.event.location,
      body: this.event.googleCalendarDescription,
      allday: false
    }).toString()

    window.open(url, '_blank')
  }

  handleGoogle () {
    const url = URI('https://calendar.google.com/calendar/r/eventedit').search({
      text: this.event.name,
      dates: [this.event.startDate, this.event.endDate].join('/'),
      details: this.event.googleCalendarDescription,
      location: this.event.location,
      sf: true,
      output: 'xml'
    }).toString()

    window.open(url, '_blank')
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/pages/community_event/javascripts/views/add_to_calendar.js